import { CartClearReason } from '@/types/cart-clear-confirmation.types';

export interface CartClearConfirmationCopy {
  title: string;
  description: string;
  confirmLabel: string;
  cancelLabel: string;
}

export const CART_CLEAR_CONFIRMATION_COPY: Record<CartClearReason, CartClearConfirmationCopy> = {
  [CartClearReason.ADDING_STANDALONE]: {
    title: 'Esvaziar carrinho para gerar Guia Avulsa?',
    description: 'Você já tem itens no carrinho. Para gerar a Guia Avulsa, eles precisam ser removidos primeiro.',
    confirmLabel: 'Esvaziar carrinho',
    cancelLabel: 'Manter itens',
  },
  [CartClearReason.CART_HAS_STANDALONE]: {
    title: 'Esvaziar carrinho para adicionar outros itens?',
    description: 'Seu carrinho já tem uma Guia Avulsa. Para adicionar outros itens, ela precisa ser removida primeiro.',
    confirmLabel: 'Esvaziar carrinho',
    cancelLabel: 'Manter Guia Avulsa',
  },
};
